function makeSlices(array, sliceSize) {
    var slices = [];
    for (var i = 0; i < array.length; i += sliceSize) {
        slices.push(array.slice(i, i + sliceSize));
    }
    return slices;
}
export var UNAUTHORIZED_ERROR_MESSAGE = 'You are not authorized to retrieve data from the Sprout API. ' +
    'Please check that your access token is valid.';
function reportErrorReason(reason, tableau) {
    var errorMessage = reason.status.toString() + ' - ' + reason.statusText;
    if (!reason.ok && reason.status === 401) {
        errorMessage = UNAUTHORIZED_ERROR_MESSAGE;
    }
    tableau.abortWithError(errorMessage);
}
export { makeSlices, reportErrorReason, };
